var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBackForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15293_15984)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 11.9997C3.33301 11.4474 3.78072 10.9997 4.33301 10.9997L17.2525 10.9997L13.6259 7.37348C13.2354 6.98298 13.2354 6.34981 13.6259 5.95927C14.0164 5.56873 14.6495 5.56869 15.0401 5.9592L20.3739 11.2925C20.5615 11.4801 20.6669 11.7344 20.6669 11.9997C20.6669 12.2649 20.5615 12.5193 20.3739 12.7068L15.0401 18.0402C14.6495 18.4307 14.0164 18.4306 13.6259 18.0401C13.2354 17.6495 13.2354 17.0164 13.6259 16.6259L17.2525 12.9997L4.33301 12.9997C3.78072 12.9997 3.33301 12.552 3.33301 11.9997Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15293_15984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackForward);
export default __webpack_public_path__ + "static/media/iconBackForward.86a35758738e73282a3526cad9f52fc3.svg";
export { ForwardRef as ReactComponent };